import {
  Box,
  CircularProgress,
  Stack,
  TablePagination,
  Typography,
} from "@mui/material";
import { type AcquiredPropertySearch } from "../types";

export const CardRow: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 1,
      py: 0.25,
    }}
  >
    <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
      {label}
    </Typography>
    <Box sx={{ textAlign: "right", minWidth: 0, overflowWrap: "anywhere" }}>
      {children}
    </Box>
  </Box>
);

interface Props {
  search: AcquiredPropertySearch;
  count: number;
  loading: boolean;
  empty: boolean;
  emptyMessage: string;
  onChange: (next: AcquiredPropertySearch) => void;
  children: React.ReactNode;
}

/** 商業登記と同じカード間隔・ページ操作を使い、ページ取得はサーバーに任せる。 */
export const MobileList: React.FC<Props> = ({
  search,
  count,
  loading,
  empty,
  emptyMessage,
  onChange,
  children,
}) => (
  <>
    {loading && empty ? (
      <Stack alignItems="center" sx={{ py: 4 }}>
        <CircularProgress size={28} />
      </Stack>
    ) : empty ? (
      <Typography sx={{ py: 4, textAlign: "center" }}>
        {emptyMessage}
      </Typography>
    ) : (
      <Stack spacing={1.5}>{children}</Stack>
    )}
    {!empty && (
      <TablePagination
        component="div"
        count={count}
        page={search.page}
        rowsPerPage={search.pageSize}
        onPageChange={(_event, page) => {
          if (!loading) onChange({ ...search, page });
        }}
        onRowsPerPageChange={(event) => {
          onChange({
            ...search,
            pageSize: Number(event.target.value),
            page: 0,
          });
        }}
        rowsPerPageOptions={[25, 50, 100]}
        labelRowsPerPage="ページあたりの行数:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}～${to} / ${count}`
        }
        sx={{
          "& .MuiTablePagination-toolbar": { flexWrap: "wrap", px: 0 },
          "& .MuiTablePagination-spacer": { display: "none" },
        }}
      />
    )}
  </>
);
